import { useMutation } from '@apollo/client'
import { AddPriceVariables, AddPrice } from '../../types'
import { ADD_DEFAULT_PRICE } from './operations'

interface Props {
  onCompleted?: () => void
}

export const useAddDefaultPrice = ({ onCompleted }: Props) =>
  useMutation<AddPrice, AddPriceVariables>(ADD_DEFAULT_PRICE, { onCompleted })
